
// import React, { useState, useEffect } from "react";
// import { Outlet } from "react-router-dom";
// import Sidebar from "./Sidebar";
// import Navbar from "./Navber";

// export default function Layout() {
//   const [isCollapsed, setIsCollapsed] = useState(false);
//   const [darkMode, setDarkMode] = useState(false);

//   // Load dark mode preference from localStorage on component mount
//   useEffect(() => {
//     const savedDarkMode = localStorage.getItem('darkMode') === 'true';
//     setDarkMode(savedDarkMode);
//   }, []);

//   // Save dark mode preference to localStorage whenever it changes
//   useEffect(() => {
//     localStorage.setItem('darkMode', darkMode.toString());
//     if (darkMode) {
//       document.documentElement.classList.add('dark');
//     } else {
//       document.documentElement.classList.remove('dark');
//     }
//   }, [darkMode]);

//   const sidebarWidth = isCollapsed ? 80 : 320;

//   return (
//     <div className={`h-screen w-screen overflow-hidden flex transition-colors duration-300 ${
//       darkMode ? 'dark bg-gray-900' : 'bg-gray-50'
//     }`}>

//       {/* Sidebar */}
//       <div
//         className="h-full transition-all duration-300 shadow-xl fixed z-50"
//         style={{ width: `${sidebarWidth}px` }}
//       >
//         <Sidebar 
//           isCollapsed={isCollapsed} 
//           setIsCollapsed={setIsCollapsed}
//           darkMode={darkMode}
//           setDarkMode={setDarkMode}
//         />
//       </div>

//       {/* Main Content */}
//       <div
//         className="flex flex-col h-full transition-all duration-300 flex-1"
//         style={{
//           marginLeft: `${sidebarWidth}px`,
//           width: `calc(100% - ${sidebarWidth}px)`,
//           minWidth: 0,
//         }}
//       >
//         <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />
//         <div className="flex-1 p-6 min-h-0 overflow-auto bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
//           <div className="max-w-full">
//             <Outlet />
//           </div>
//         </div>
//       </div>

//     </div>
//   );
// }
import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Navbar from "./Navber";
import { FiExternalLink } from "react-icons/fi"; // Import external link icon

export default function Layout() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  // Load dark mode preference from localStorage on component mount
  useEffect(() => {
    const savedDarkMode = localStorage.getItem('darkMode') === 'true';
    setDarkMode(savedDarkMode);
  }, []);

  // Save dark mode preference to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('darkMode', darkMode.toString());
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  const sidebarWidth = isCollapsed ? 80 : 320;

  return (
    <div className={`h-screen w-screen overflow-hidden flex flex-col transition-colors duration-300 ${
      darkMode ? 'dark bg-gray-900' : 'bg-gray-50'
    }`}>

      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar */}
        <div
          className="h-full transition-all duration-300 shadow-xl fixed z-50"
          style={{ width: `${sidebarWidth}px` }}
        >
          <Sidebar 
            isCollapsed={isCollapsed} 
            setIsCollapsed={setIsCollapsed}
            darkMode={darkMode}
            setDarkMode={setDarkMode}
          />
        </div>

        {/* Main Content */}
        <div
          className="flex flex-col flex-1 h-full transition-all duration-300"
          style={{
            marginLeft: `${sidebarWidth}px`,
            width: `calc(100% - ${sidebarWidth}px)`,
            minWidth: 0,
          }}
        >
          <Navbar darkMode={darkMode} setDarkMode={setDarkMode} />
          <div className="flex-1 min-h-0 overflow-auto bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
            <div className="p-6 min-h-full flex flex-col">
              {/* Main Content Area */}
              <div className="flex-1">
                <Outlet />
              </div>
              
              {/* Footer */}
              <footer className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-800">
                <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-gray-500 dark:text-gray-400">
                  <div>
                    © {new Date().getFullYear()} Gokhale Memorial Girls' College. All rights reserved.
                  </div>
                  <a 
                    href="https://www.ebluesys.com/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-purple-600 dark:text-purple-400 hover:text-purple-800 dark:hover:text-purple-300 transition-colors duration-300 font-medium group"
                  >
                    <span>Developed by EBLUESYS</span>
                    <FiExternalLink className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300" />
                  </a>
                </div>
              </footer>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}